import { call, put, takeLatest } from 'redux-saga/effects';

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const RESET = 'RESET';

export const createRequestTypes = (base) => ({
  REQUEST: `${base}_${REQUEST}`,
  LOADING: `${base}_${LOADING}`,
  SUCCESS: `${base}_${SUCCESS}`,
  ERROR: `${base}_${ERROR}`,
  RESET: `${base}_${RESET}`,
});

export const createActionCreators = (base, overridePayload) => {
  const type = createRequestTypes(base);
  return {
    request: (payload) => ({ type: type.REQUEST, payload: { ...payload, ...overridePayload } }),
    success: (payload) => ({ type: type.SUCCESS, payload }),
    failure: (error) => ({ type: type.FAILURE, error }),
    reset: () => ({ type: type.RESET }),
    loading: (payload) => ({ type: type.LOADING, payload }),
    TYPE: type,
  };
};

export const createReducer = (type) => {
  const initialState = {
    loading: false,
    data: null,
    error: null,
  };

  return (state = initialState, action) => {
    switch (action.type) {
    case type.REQUEST:
      return { ...state, loading: true, error: null };
    case type.SUCCESS:
      return {
        ...state, loading: false, data: action.payload, error: null,
      };
    case type.FAILURE:
      return { ...state, loading: false, error: action.error };
    case type.RESET:
      return initialState;
    default:
      return state;
    }
  };
};

const createSaga = (type, apiCall, customHandler) => {
  function* handleRequest(action) {
    try {
      if (customHandler?.before) yield customHandler.before(action);
      const response = yield call(apiCall, action.payload);
      if (response?.success) {
        yield put({ type: type.SUCCESS, payload: response?.data });
      } else {
        throw new Error(response?.message);
      }
      if (action?.callback) action.callback();
      if (customHandler?.afterSuccess) yield customHandler.afterSuccess(response);
    } catch (error) {
      yield put({ type: type.FAILURE, error });
      if (customHandler?.onError) yield customHandler.onError(error);
    } finally {
      if (customHandler?.finally) yield customHandler.finally(action);
    }
  }

  return function* watchSaga() {
    yield takeLatest(type.REQUEST, handleRequest);
  };
};

export const action = (type, payload = {}) => ({ type, ...payload });
